import { doc, getDoc, updateDoc } from "firebase/firestore";
import eventBus from "./eventBus";
import dreamWorldProvider from "../DreamWorldProvider";

const db = dreamWorldProvider.getDb();
export const getFluxBalance = async (userId: string): Promise<number> => {
  const userRef = doc(db, "users", userId);
  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    return userDoc.data().flux || 0;
  }
  return 0;
};

export const decreaseFluxBalance = async (
  userId: string,
  amount: number
): Promise<boolean> => {
  const userRef = doc(db, "users", userId);
  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    const currentBalance = userDoc.data().flux || 0;
    if (currentBalance >= amount) {
      const newBalance = currentBalance - amount;
      await updateDoc(userRef, { flux: newBalance });
      eventBus.emit("flux-balance-changed", newBalance);
      return true;
    }
  }
  return false;
};

export const hasEnoughFlux = async (
  userId: string,
  amount: number
): Promise<boolean> => {
  const balance = await getFluxBalance(userId);
  return balance >= amount;
};
